// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"User__srOnly--1vvkK","hiddenInput":"User__hiddenInput--LTV-X","root":"User__root--141BB","myaccount":"User__myaccount--1D9Th","header":"User__header--2vNsJ"};